module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/2019_professional_winner-da55b1bee5bae7027e7642b2c19ecc71.jpg";